import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { LoginRequest, LoginResponse, AdminUser } from '../models';

export { LoginRequest, LoginResponse, AdminUser };

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private http = inject(HttpClient);
  private router = inject(Router);
  private baseUrl = environment.apiUrl;

  login(credentials: LoginRequest): Observable<LoginResponse> {
    return this.http.post<LoginResponse>(`${this.baseUrl}/auth/login`, credentials).pipe(
      tap(res => {
        if (res.success && res.token) {
          localStorage.setItem('pc_token', res.token);
          localStorage.setItem('pc_username', res.username);
          localStorage.setItem('pc_name', res.name);
        }
      })
    );
  }

  logout(): void {
    localStorage.removeItem('pc_token');
    localStorage.removeItem('pc_username');
    localStorage.removeItem('pc_name');
    this.router.navigate(['/login']);
  }

  isLoggedIn(): boolean {
    return !!localStorage.getItem('pc_token');
  }

  getToken(): string | null {
    return localStorage.getItem('pc_token');
  }

  getUserName(): string {
    return localStorage.getItem('pc_name') || localStorage.getItem('pc_username') || 'Usuário';
  }
}
